import { createReducer } from 'redux-act'

import BulkInquiryState from './types'
import { selectListing, deselectListing, clearSelection, setSelectMode, setFilterContext } from './actions'
import initialState from './state'
import { BULK_INQUIRY } from '../../constants/search-result-listing'
import { ListingSectionObject } from '../../transports/common/listing-section-transport'

const _selectListing = (state: BulkInquiryState, payload: ListingSectionObject): BulkInquiryState => {
    const id = String(payload.id)

    if (state.selectedListings[id]) {
        return state
    }

    if (Object.keys(state.selectedListings).length >= BULK_INQUIRY.MAX_SELECTION) {
        return state
    }

    return {
        ...state,
        selectedListings: { ...state.selectedListings, [id]: payload },
        selectionOrder: [...state.selectionOrder, id],
    }
}

const _deselectListing = (state: BulkInquiryState, payload: string): BulkInquiryState => {
    if (!state.selectedListings[payload]) {
        return state
    }

    const { [payload]: _removed, ...rest } = state.selectedListings
    return {
        ...state,
        selectedListings: rest,
        selectionOrder: state.selectionOrder.filter(id => id !== payload),
    }
}

const _clearSelection = (state: BulkInquiryState): BulkInquiryState => ({
    ...state,
    selectedListings: {},
    selectionOrder: [],
})

const _setSelectMode = (state: BulkInquiryState, payload: boolean): BulkInquiryState => ({
    ...state,
    isSelectMode: payload,
    selectedListings: payload ? state.selectedListings : {},
    selectionOrder: payload ? state.selectionOrder : [],
})

const _setFilterContext = (state: BulkInquiryState, payload: string): BulkInquiryState => {
    if (state.filterKey === payload) {
        return state
    }
    return {
        ...state,
        filterKey: payload,
        selectedListings: {},
        selectionOrder: [],
    }
}

const reducer = createReducer<BulkInquiryState>(on => {
    on(selectListing, _selectListing)
    on(deselectListing, _deselectListing)
    on(clearSelection, _clearSelection)
    on(setSelectMode, _setSelectMode)
    on(setFilterContext, _setFilterContext)
}, initialState)

export default reducer
